import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';

import TreasuryFileUpload from './TreasuryFileUpload';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';
import {
  harmonateDialogPaperProps,
  harmonateDialogTitleSx,
  harmonateDialogCloseIconSx,
} from '../../../theme/harmonateStyles';

const TreasuryFileUploadDialog = ({ open, onClose, onUploadComplete }) => {
  const handleCloseDialog = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          ...harmonateDialogPaperProps.sx,
          maxHeight: '95vh',
        },
      }}
    >
      <DialogTitle sx={harmonateDialogTitleSx}>
        <Box>
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, color: ht.white }}>
            Upload Treasury Files
          </Typography>
        </Box>
        <IconButton aria-label="close" onClick={handleCloseDialog} sx={harmonateDialogCloseIconSx}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, pt: '0 !important' }}>
        <TreasuryFileUpload 
          onClose={handleCloseDialog}
          onUploadComplete={onUploadComplete}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TreasuryFileUploadDialog;
